//
// BASEline jump re-play with body position
//
define('replay/replay',["require", "exports", "../tracks/track-state", "../util/log", "./geometry", "./materials"], function (require, exports, trackState, log, geometry_1, materials_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.init = void 0;
    var bodyPosition = document.getElementById("body-position");
    var width = 420;
    var height = 420;
    var render;
    var wingsuit;
    var vel;
    var lineGeometry;
    function init() {
        try {
            initUnsafe();
        }
        catch (e) {
            console.error("three.js error " + e);
            log.error("three.js init error " + e);
        }
    }
    exports.init = init;
    function initUnsafe() {
        // Initialize three.js
        var scene = new THREE.Scene();
        scene.background = new THREE.Color(0xeeeeee);
        var camera = new THREE.PerspectiveCamera(75, width / height, 0.1, 1000);
        camera.position.z = -4;
        var renderer = new THREE.WebGLRenderer({ alpha: true });
        renderer.setSize(width, height);
        new THREE.OrbitControls(camera, renderer.domElement);
        bodyPosition.appendChild(renderer.domElement);
        // Add background cubemap
        scene.background = materials_1.default.backgroundCubeMap();
        // Add north indicator
        new THREE.FontLoader().load("https://threejs.org/examples/fonts/helvetiker_regular.typeface.json", function (font) {
            var northMesh = new THREE.Mesh(geometry_1.default.north(font), materials_1.default.north());
            northMesh.position.z = 2.5;
            northMesh.position.x = -0.15;
            northMesh.rotation.x = -Math.PI / 2;
            scene.add(northMesh);
        });
        // Add ambient light
        scene.add(new THREE.AmbientLight(0xeeeeee));
        // TODO: Add light in position where sun would be
        var light = new THREE.DirectionalLight(0xeeeecc, 0.9);
        scene.add(light);
        // Draw axes
        scene.add(new THREE.AxesHelper(1));
        // Make a wingsuiter
        new THREE.GLTFLoader().load("/assets/images/3d/wingsuit4.glb", function (gltf) {
            wingsuit = gltf.scene.children[0];
            wingsuit.geometry.computeFaceNormals();
            wingsuit.geometry.computeVertexNormals();
            wingsuit.scale.set(0.04, 0.04, 0.04);
            scene.add(wingsuit);
        });
        // wingsuit = new THREE.Mesh(geometry.wingsuit(), materials.wingsuit())
        // wingsuit.rotation.order = "YXZ"
        // wingsuit.geometry.computeFaceNormals()
        // wingsuit.geometry.computeVertexNormals()
        // scene.add(wingsuit)
        // Draw velocity line
        lineGeometry = new THREE.Geometry();
        lineGeometry.vertices.push(new THREE.Vector3(0, 0, 0), new THREE.Vector3(0, 0, 2));
        scene.add(new THREE.Line(lineGeometry, materials_1.default.velocityLine()));
        // Make a velocity cone
        var velgeometry = new THREE.CylinderGeometry(0, 0.1, 0.4, 16);
        vel = new THREE.Mesh(velgeometry, materials_1.default.velocityArrow());
        vel.position.z = 2;
        vel.rotation.order = "ZYX";
        vel.visible = false;
        scene.add(vel);
        render = function () {
            requestAnimationFrame(render);
            renderer.render(scene, camera);
        };
        render();
        // Listen for updates
        trackState.focusUpdates.subscribe(function (point) { return drawFocus(point); });
    }
    // Convert x,y,z vector to pitch and yaw orientation
    function vectorToOrient(x, y, z) {
        var mag = Math.sqrt(x * x + y * y + z * z);
        var pitch = Math.asin(y / mag);
        var yaw = Math.atan2(-x, z);
        return [pitch, yaw];
    }
    function drawFocus(point) {
        if (point) {
            // Velocity vector
            var x = -point.vE; // west
            var y = point.climb; // up
            var z = point.vN; // north
            var _a = vectorToOrient(x, y, z), pitch = _a[0], yaw = _a[1];
            var roll = point.roll || 0;
            vel.rotation.x = -pitch + Math.PI / 2;
            vel.rotation.y = -yaw;
            vel.position.x = x / 25;
            vel.position.y = y / 25;
            vel.position.z = z / 25;
            vel.visible = true;
            lineGeometry.vertices[1].set(x / 25, y / 25, z / 25);
            lineGeometry.verticesNeedUpdate = true;
            // Wingsuit orientation
            wingsuit.rotation.x = Math.PI + pitch; // + aoa(point.sustained_x)
            wingsuit.rotation.y = yaw;
            wingsuit.rotation.z = -roll;
        }
    }
});
// /**
//  * Approximate AoA in degrees, given sustained speed (m/s)
//  */
// function aoa(sustainedX: number): number {
//   return -0.626 * sustainedX + 40
// }
//# sourceMappingURL=/assets/javascripts/replay/replay.js.map;
